export default __webpack_public_path__ + "static/media/movies-bg.10641e20.png";